<template>
  <b-sidebar
    v-model="modalOpen"
    v-if="modalOpen"
    centered
    id="branchModal"
    class="edit-modal"
    width="500px"
    backdrop
    no-close-on-backdrop
    no-close-on-esc
    no-header
    body-class="bg-white"
  >
    <div class="p-2">
      <validation-observer ref="branchValidation">
        <b-form @submit.prevent="onSubmit">
          <b-row>
            <b-col class="d-flex justify-content-between" cols="12">
              <h3> {{ mainTitle }} </h3>
              <feather-icon
                size="20"
                class="cursor-pointer"
                @click="modalOpen = false"
                icon="XIcon"
              />
            </b-col>
            <b-col cols="12">
              <hr />
            </b-col>
            <b-col cols="12">

              <form-select
                label="رقم و تاريخ اجتماع مجلس الإدارة / الإمناء المتضمن الموافقة على إحداث الفرع"
                v-model="form.meeting_minute_id"
                :getOptionLabel="(x) => x.meeting_minutes_label"
                :reduce="(x) => x"
                id="gov"
                ep="v2/selects/meeting-minutes"
                ref="gov"
                rules="required"
              />

              <small class="text-secondary mb-1 d-block" style="margin-top: -10px;">
                في حال عدم وجود محضر الاجتماع يُرجى تقديم معاملة بالمحضر الجديد
              </small>
            </b-col>
            <b-col cols="12" class="mb-1 mt-1">
              <span class="text-muted">
                <feather-icon icon="InfoIcon" /> قم بالضغط على رمز الخريطة للبحث
                عن الموقع</span
              >
            </b-col>
            <b-col cols="12" class="d-flex align-items-center">
              <form-input
                readonly
                style="width: 40%"
                rules="required"
                label="خط الطول"
                v-model="form.longitude"
              />
              <form-input
                readonly
                class="mx-50"
                style="width: 40%"
                rules="required"
                label="خط العرض"
                v-model="form.latitude"
              />
              <b-button
                @click="mapModal = true"
                class="btn btn-primary mt-50"
                variant="flat-primary"
              >
                <feather-icon icon="MapPinIcon" />
              </b-button>
            </b-col>
            <b-col cols="12">
              <form-select
                label="رقم العقار"
                v-model="form.real_estate_id"
                :getOptionLabel="(x) => x.number"
                :reduce="(x) => x"
                id="branhc-real-estate-id"
                ep="v"
                ref="branchRealEstates"
                 rules="required"
                
              />
              <small class="text-muted"
                >تظهر فقط أرقام العقارات للمحافظة التي قمت باختيارها</small
              >
            </b-col>

            <b-col v-if="form.branch_type_id === 1" cols="12">
              <form-mask
                placeholder="YYYY-MM-DD"
                options="date"
                rules="required"
                label="تاريخ قرار الإشهار"
                v-model="form.decision_date"
              />
            </b-col>
            <b-col cols="12">
              <form-textarea
                label="الخدمات المقدمة"
                rows="3"
                v-model="form.services"
                placeholder="وصف عن الخدمة وما تقدمه"
                rules="required"
              />
            </b-col>
            <b-col cols="12">
              <b-row>
                <b-col  cols="12 " class="mt-2">
                  <div class="d-flex justify-content-between">
                    <p>
                      أسماء أعضاء اللجنة الإدارية  :
                    </p>
                    <b-button
                      variant="outline-success"
                      @click="onClickedAdd"
                      size="sm"
                    >
                      <feather-icon icon="PlusIcon" />
                      إضافة
                    
                    </b-button>

                  </div>
                
                  <hr />
                </b-col>
                <b-col v-if="isOver" cols="12">
                  <small class="text-danger"> يجب أن يكون عدد الأعضاء بين 3 و 5 أعضاء </small>

                </b-col>
                <b-col cols="12"  v-for="(member, memberId) in form.administrativeCommittee" :key="memberId">
                  <b-row>
                    <b-col cols="6" class="my-1">
                      العضو {{ getArrangement(memberId+1) }}
                    </b-col>
                    <hr />
                    <b-col cols="6" class="d-flex justify-content-end align-items-start my-1">
                      <b-button
                        variant="outline-danger"
                        @click="onClickedDeleted(memberId)"
                        size="sm"
                      >
                        <feather-icon icon="PlusIcon" />
                        حذف
                      
                      </b-button>
                    </b-col>
                    
                    <b-col cols="12">
                      <form-select
                        :placeholder= "`${memberId+1} - الاسم `"
                        :getOptionLabel="(x) => x.employee_or_volunteer_label"
                        :reduce="(x) => x"
                        id="employees_and_volunteers"
                        ep="v2/selects/employees-and-volunteers"
                        ref="employees_and_volunteers"
                        v-model="member.employee_id"
                        rules="required"
                      />
                    </b-col>
                    <b-col cols="12">
                      <form-file-input
                        :placeholder="`${memberId+1} - نشرة الاستعلام`"
                        id="document"
                        v-model="member.security_dossier"
                        rules="required"
                        accept=".doc,.pdf,.docx,.png"
                      />
                    </b-col>
                    <b-col cols="12" v-if="memberId !== form.administrativeCommittee.length-1">
                      <hr />
                    </b-col>
                  </b-row>
                </b-col>
                  </b-row>
            </b-col>
          </b-row>
          <hr />

          <b-row class="px-1 justify-content-end">
            <b-button @click="modalOpen = false" class="mx-1">إلغاء</b-button>
            <save-btn
              type="submit"
              variant="success"
              :loading="loading"
              :label="btnLabel"
            >
            </save-btn>
          </b-row>
        </b-form>
      </validation-observer>
    </div>
    <b-modal
      v-model="mapModal"
      centered
      size="lg"
      title="موقع الفرع"
      footer-class="removed"
      class="edit-modal"
      id="branchModal"
    >
      <map-select
        @closeModal="mapModal = false"
        @markerUpdated="onLocationSelect"
        :govsEndpoint.sync="govEp"
      />
    </b-modal>
  </b-sidebar>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BCardText,
  BCardTitle,
  BModal,
  BFormGroup,
  BFormFile,
  BFormRadio,
  BForm,
  BFormTextarea,
  BButton,
  BSidebar,
} from "bootstrap-vue";
import { ValidationObserver } from "vee-validate";
import formSelect from "@/components/form-select";
import formInput from "@/components/form-input";
import formTextarea from "@/components/form-textarea";
import saveBtn from "@/components/loader-btn";
import FormMask from "@/components/form-mask";
import { required, integer } from "@validations";
// import mapSelect from "@/components/map-select";
import mapSelect from "../map-select/index.vue";
import { ValidationProvider } from "vee-validate";
import FormFileInput from "@/components/FormFileInput.vue";
import { arrangement } from "@/utils/utils";
const initForm = {};
export default {
  components: {
    formInput,
    formTextarea,
    formSelect,
    BButton,
    BSidebar,
    FormMask,
    saveBtn,
    BRow,
    BCol,
    mapSelect,
    BCard,
    BCardText,
    BCardTitle,
    BModal,
    BFormGroup,
    BFormFile,
    BForm,
    BFormRadio,
    BFormTextarea,
    ValidationObserver,
    ValidationProvider,
    FormFileInput
  },
  props: {
    value: Boolean,
    title: String,
    mainTitle: {
      type: String,
      default: () => "معلومات فرع",
    },
    btnLabel: String,
    loading: Boolean,
    intializeForm: {
      type: Object,
      default: () => initForm,
    },
  },
  data() {
    return {
      form: {},
      required,
      integer,
      govId: null,
      mapModal: false,
      isOver : false ,
    };
  },
  computed: {
    modalOpen: {
      set(val) {
        this.$emit("input", val);
      },
      get() {
        return this.value;
      },
    },
    branchTypes() {
      return this.$store.getters["branch-types/options"];
    },
    govEp() {
      return "v2/selects/available-unKnown-branch-governorates";
    },
  },
  watch: {
    modalOpen(val) {
      if (val)
        this.$nextTick(() => {
          // this.init(this.intializeForm);
        });
    },
    govId(val) {
      if (val) {
        this.$refs.branchRealEstates.refreshOptions(
          `v2/selects/real-estates?gid=${val.id}`
        );
        // delete this.form.real_estate_id;
      }
    },
    govEp: {
      immediate: true,
      handler(val) {
        if (this.$refs.govs) this.$refs.govs.refreshOptions(val);
      },
    },
  },

  methods: {
    init(form) {
      this.form = JSON.parse(JSON.stringify(form));
      if (form.governorate_id) {
        this.govId = form.governorate_id;
        this.form.real_estate_id = form.real_estate_id;
      }
    },
    typeInputHandle(e) {
      this.$delete(this.form, "sub_district_id");
      this.$delete(this.form, "decision_date");
      this.$delete(this.form, "administrativeCommittee");
    },
    onLocationSelect(e) {
      this.form.governorate_id = e.govId;
      this.form.longitude = e.pos.lng;
      this.form.latitude = e.pos.lat;
      this.form.sub_district_id = e.area;
      this.form.address = e.address;
      this.govId = e.govId;
    },
    async onSubmit() {
      await this.$refs.branchValidation.validate().then(async (success) => {
        if(!this.form.hasOwnProperty('administrativeCommittee') || Object.keys(this.form.administrativeCommittee).length < 3 ){
          this.isOver = true
        }
        else{
          this.isOver = false
        }
        if (success) {
          if(this.isOver === false )
          {
            this.$emit("confirm", this.form);
          }
        }
      });
    },
    getArrangement(num){
      return arrangement(num)
    },
     onClickedAdd(){
      if(!this.form.hasOwnProperty('administrativeCommittee') || Object.keys(this.form.administrativeCommittee).length === 0 ){
        this.form.administrativeCommittee =[{}]
        this.init(this.form )
      }
      else if(Object.keys(this.form.administrativeCommittee).length < 5  ){
        
        // check if any form station => open without save Data
        let i=0
        if(this.form.administrativeCommittee.length === 0)
        {
          this.form.administrativeCommittee.push({})
        }
        
        else{
          for(let item of this.form.administrativeCommittee)
          {
            i +=1
            if(Object.keys(item).length === 0)
            {
              this.form.administrativeCommittee.splice(i-1, 1) 
            }
        
        
          }
          this.form.administrativeCommittee.push({})
        }

        this.isOver = false

      }
      else{
        this.isOver = true
      }
    },
    onClickedDeleted (index){
      this.form.administrativeCommittee.splice(index, 1) 
    },
  },
};
</script>
